module.exports = __webpack_public_path__ + "906bd3dd2de7301403f4a8add5baca8f.jpg";